




import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ProgramProgress extends Vue {
  @Prop({ type: Number, default: 0 }) value!: number;
  @Prop({ type: Number, default: 1 }) max!: number;
}
